import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';

const ConfirmDeleteModal = ({ isOpen, toggle, message = 'Tem certeza?', title = 'Confirmar exclusão', onConfirm, btnConfirm = 'Excluir', btnCancel = 'Cancelar', confirmColor = 'danger' }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>{message}</ModalBody>
      <ModalFooter className="pt-3 pb-3 px-3">
        <div className="w-100 d-flex justify-content-end">
          <Button color="secondary" onClick={toggle} className="mr-2">
            {btnCancel}
          </Button>
          <Button color={confirmColor} onClick={() => { onConfirm && onConfirm(); toggle && toggle(); }}>
            {btnConfirm}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmDeleteModal;
